import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import axios from 'axios';
import { API_URL } from '../../config/api';
import { useTranslation } from '../../hooks/useTranslation';
import { useLanguage } from '../../context/LanguageContext';
import './css/AdminPages.css';

const DEFAULT_FORM = {
  phone: '',
  whatsapp: '',
  email: '',
  address_ar: '',
  address_en: '',
  website: '',
  instagram: '',
  snapchat: '',
  tiktok: '',
  x: '',
  facebook: '',
  youtube: ''
};

const ContactSettings = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { language, isRTL, toggleLanguage } = useLanguage();
  const [form, setForm] = useState(DEFAULT_FORM);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/settings/contact`);
        setForm({ ...DEFAULT_FORM, ...(res.data?.contact || {}) });
      } catch (e) {
        setForm(DEFAULT_FORM);
      }
    };
    fetchContact();
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(`${API_URL}/api/settings/contact`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert(t('admin.savedContact'));
    } catch (e) {
      alert(e.response?.data?.message || t('admin.error'));
    } finally {
      setSaving(false);
    }
  };

  const setValue = (key, value) => setForm((p) => ({ ...p, [key]: value }));

  return (
    <div className={`admin-page ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className='admin-header'>
        <button onClick={() => navigate('/admin/dashboard')} className='back-btn'>
          <ArrowLeftIcon className='icon' />
          {t('admin.back')}
        </button>
        <h1>{t('admin.contactSettings')}</h1>
        <div className='header-actions'>
          <button onClick={toggleLanguage} className='language-toggle-btn'>
            {language === 'ar' ? 'EN' : 'AR'}
          </button>
        </div>
      </div>

      <div className='admin-table-container'>
        <form onSubmit={save}>
          <div className='form-group'><label>{t('contact.phone')}</label><input value={form.phone} onChange={(e) => setValue('phone', e.target.value)} /></div>
          <div className='form-group'><label>{t('contact.whatsapp')}</label><input value={form.whatsapp} onChange={(e) => setValue('whatsapp', e.target.value)} /></div>
          <div className='form-group'><label>{t('contact.email')}</label><input type='email' value={form.email} onChange={(e) => setValue('email', e.target.value)} /></div>
          <div className='form-group'><label>{t('contact.address')} (AR)</label><textarea value={form.address_ar} onChange={(e) => setValue('address_ar', e.target.value)} /></div>
          <div className='form-group'><label>{t('contact.address')} (EN)</label><textarea value={form.address_en} onChange={(e) => setValue('address_en', e.target.value)} /></div>
          <div className='form-group'><label>{t('contact.website')}</label><input value={form.website} onChange={(e) => setValue('website', e.target.value)} placeholder='https://example.com' /></div>
          <div className='form-group'><label>Instagram</label><input value={form.instagram} onChange={(e) => setValue('instagram', e.target.value)} /></div>
          <div className='form-group'><label>Snapchat</label><input value={form.snapchat} onChange={(e) => setValue('snapchat', e.target.value)} /></div>
          <div className='form-group'><label>TikTok</label><input value={form.tiktok} onChange={(e) => setValue('tiktok', e.target.value)} /></div>
          <div className='form-group'><label>X</label><input value={form.x} onChange={(e) => setValue('x', e.target.value)} /></div>
          <div className='form-group'><label>Facebook</label><input value={form.facebook} onChange={(e) => setValue('facebook', e.target.value)} /></div>
          <div className='form-group'><label>YouTube</label><input value={form.youtube} onChange={(e) => setValue('youtube', e.target.value)} /></div>
          <div className='modal-actions'>
            <button type='submit' className='save-btn' disabled={saving}>{saving ? t('admin.saving') : t('admin.save')}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactSettings;
